import React from 'react';
import { motion } from 'framer-motion';
import { closingLines, productShortName } from '../data/offer';
export function ClosingSection() {
  return <section className="bg-stage tech-grid py-16 sm:py-20" aria-labelledby="closing-title" data-id="element-47" data-mp="ov5gejrmpv9a">
      <div className="mx-auto max-w-4xl px-4" data-id="element-48" data-mp="12u551rf56a5g">
        <div className="text-center" data-id="element-49" data-mp="xt90dbmyujyz">
          <h2 id="closing-title" className="text-balance text-3xl font-extrabold leading-tight text-white sm:text-4xl" data-id="element-50" data-mp="xs7f6ec8kh3j">
            El próximo lunes puedes seguir improvisando…
          </h2>
          <p className="mt-4 font-display text-2xl font-extrabold text-gold sm:text-3xl" data-id="element-51" data-mp="17r57lscs8urt">
            O puedes entrar al aula con todo listo desde hoy.
          </p>
        </div>

        <ul className="mx-auto mt-10 grid max-w-3xl gap-3" data-id="element-52" data-mp="1hhhv9tfw9426">
          {closingLines.map((line, index) => <motion.li key={line} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.28,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className="panel-dark flex items-center gap-3 rounded-lg border-l-4 border-gold px-4 py-3 text-sm font-semibold text-onDark" data-id="element-53" data-mp="1viapse673z5a" data-mpi={index}>
              <span className="font-display text-gold" aria-hidden="true" data-id="element-54" data-mp="2ccmm4easygjc">
                ▸
              </span>
              {line}
            </motion.li>)}
        </ul>

        <div className="mx-auto mt-10 max-w-2xl text-center" data-id="element-55" data-mp="2laosl9db21e0">
          <p className="leading-relaxed text-mutedDark" data-id="element-56" data-mp="2q9jbebb9vpy4">
            El {productShortName} no te convierte en mejor docente. Vos ya eres un buen docente.
          </p>
          <p className="mt-3 text-lg font-bold text-white" data-id="element-57" data-mp="2v3dupdmyu2wo">
            Lo que hace el megapack es darte el tiempo y las herramientas para que eso se note en cada clase.
          </p>
        </div>
      </div>
    </section>;
}